import styled from 'styled-components'

export const Image = styled.img`
	display: flex;
	height: 36px;
	width: 36px;
	background-color: green;
	border-radius: 50%;
	object-fit: cover;
	object-position: center;
	vertical-align: middle;
`
